import { History } from "lucide-react";
import type { Task } from "../../mock/types";
import { formatDueDate } from "../../mock/helpers";

export function HistorySection({ task }: { task: Task }) {
	return (
		<section>
			<div className="mb-3 flex items-center gap-2">
				<History className="h-4 w-4 text-muted" />
				<h3 className="text-sm font-semibold text-foreground">
					Activity
				</h3>
			</div>
			{task.history.length === 0 ? (
				<p className="text-xs text-muted">No activity recorded.</p>
			) : (
				<ul className="space-y-2.5">
					{task.history.map((h) => (
						<li key={h.id} className="flex gap-2.5">
							<span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-border-strong" />
							<div className="text-sm">
								<span className="font-medium text-foreground">
									{h.actor.full_name ?? h.actor.email}
								</span>{" "}
								<span className="text-muted">{h.summary}</span>
								<span className="ml-1.5 text-xs text-muted">
									· {formatDueDate(h.created_at)}
								</span>
							</div>
						</li>
					))}
				</ul>
			)}
		</section>
	);
}
